/* eslint-disable max-lines */
import React, {
    useContext, useEffect, useState
} from 'react';
import {
    Context
} from 'shared/context/GlobalState';
import {
    httpRequest
} from 'shared/utils/httpsRequest';
import {
    BsPersonFillAdd
} from 'react-icons/bs';
import {
    AppLoader, LoaderSpinner
} from 'shared/components/LoaderSpinner';
import AddUserForm from 'features/organizations/members/AddUserForm';
import {
    useParams
} from 'react-router-dom';
import {
    MdDelete, MdEdit
} from 'react-icons/md';
import AlertModal from 'shared/components/Alertmodal';
import InviteUserForm from 'features/organizations/members/InviteUserForm';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from 'shared/components/ui/dialog';
import {
    Button
} from 'shared/components/ui/button';
import {
    Tabs, TabsList, TabsTrigger, TabsContent
} from 'shared/components/ui/tabs';
import NewStyledTable from 'shared/components/ui/StyledTable';
import {
    OrganizationContext
} from 'shared/context/OrganizationContext';

function UsersSetting() {
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [alertModal, setAlertModal] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [userInput, setUserInput] = useState({
        email: '',
        role: 'editor'
    });
    const [inviteUserInput, setInviteUserInput] = useState({
        email: '',
        role: 'editor'
    });
    const [selectedItem, setSelectedItem] = useState({});
    const [currentTab, setCurrentTab] = useState('add-member');

    const {
        addNewNotifcation
    } = useContext(Context);
    const {
        getUserRole
    } = useContext(OrganizationContext);
    const {
        oragID
    } = useParams();

    const roleInstance = getUserRole();

    useEffect(() => {
        httpRequest.get(`/db/users/getUsers/${oragID}`)
            .then((res) => {

                const editable = res.data.map((item) => {
                    if (item.role === 'super admin') {
                        item.editable = false;
                    }

                    return {
                        id: item._id,
                        ...item
                    };
                });
                setTableData(editable);
            }).catch(() => {

            }).finally(() => {
                setLoading(false);
            });
    }, []);

    const handleCreate = () => {
        if (!userInput.email) {
            return addNewNotifcation('Please fill in all fields', 'warning');
        }

        const orgObj = {
            email: userInput.email,
            type: userInput.role,
            organizationId: oragID
        };

        setBtnLoading(true);

        httpRequest.post('/db/organizations/update_organization/add-member', orgObj)
            .then((res) => {

                const updatedUser = {
                    ...res.data
                };
                updatedUser['id'] = updatedUser._id;
                setTableData(prev => ([...prev, updatedUser]));

                addNewNotifcation('Organization Member added successfully.', 'success');
                setOpenModal(false);

            })
            .catch((error) => {

                if (error.response?.status === 404) {
                    addNewNotifcation('Organization Member could not be added. User is not registered. Please check all your entries.', 'danger');
                } else if (error.response?.status === 409) {
                    addNewNotifcation('Organization Member could not be added. User is already a member of an organization.', 'danger');
                } else if (error.response?.status === 401) {
                    addNewNotifcation('Organization Member could not be added. Admin are not authorized to add admin.', 'danger');
                } else {
                    addNewNotifcation('Organization Member could not be added. Please try again.', 'danger');
                }
            })
            .finally(() => setBtnLoading(false));
    };

    const handleInvite = () => {

        if (!inviteUserInput.email) {
            return addNewNotifcation('Please fill in all fields', 'warning');
        }

        setBtnLoading(true);

        const inviteObj = {
            email: inviteUserInput.email,
            organizationId: oragID,
            role: inviteUserInput.role,
        };

        httpRequest.post('/db/organizations/invite-to-join-organization', inviteObj)
            .then(() => {
                addNewNotifcation('Invitation has been sent successfully.', 'success');
                setOpenModal(false);
            })
            .catch((error) => {

                if (error.response?.status === 409) {
                    addNewNotifcation('Invitation could not be sent. User already exist.', 'danger');
                } else {
                    addNewNotifcation('Invitation could not be sent. Please try again.', 'danger');
                }
            })
            .finally(() => setBtnLoading(false));

    };

    const handleDelete = (itemId) => {
        if (roleInstance.isSuperAdmin || roleInstance.isAdmin) {
            const memberData = tableData.find((item) => item.id === itemId);
            if (roleInstance.isAdmin && memberData?.role === 'admin') {
                return addNewNotifcation('Sorry, you are not authorized to remove admin members', 'warning');
            }
            setAlertModal(true);
            setSelectedItem(memberData);
        } else {
            addNewNotifcation('Sorry, you are not authorized to remove users', 'danger');
        }
    };

    const handleUpdate = (itemId) => {
        if (roleInstance.isSuperAdmin || roleInstance.isAdmin) {
            const memberData = tableData.find((item) => item.id === itemId);
            if (roleInstance.isAdmin && memberData?.role === 'admin') {
                return addNewNotifcation('Sorry, you are not authorized to update admin members', 'warning');
            }
            setOpenUpdateModal(true);
            setSelectedItem(memberData);
        } else {
            addNewNotifcation('Sorry, you are not authorized to update users', 'danger');
        }
    };

    // The failure message for one member, by HTTP status.
    const removalErrorMessage = (error) => {
        if (error.response?.status === 404)
            return 'User is not registered. Please check all your entries.';
        if (error.response?.status === 401)
            return error.response.data?.message || 'You do not have the right access.';
        return 'Please try again.';
    };

    const handleOnDelete = () => {
        setBtnLoading(true);

        // selectedItem is EITHER one member record (the row action) or an ARRAY
        // of row ids (the multi-select action). Normalise to member records so
        // both paths share one code path: reading `._id` off an array yields
        // undefined, JSON.stringify then drops the key, and the request went out
        // as {organizationId} alone — the server's '"userId" is required' 400.
        const selection = Array.isArray(selectedItem)
            ? selectedItem
                .map((rowId) => tableData.find((item) => item.id === rowId || item._id === rowId))
                .filter(Boolean)
            : selectedItem
                ? [selectedItem]
                : [];

        if (selection.length === 0) {
            setBtnLoading(false);
            setAlertModal(false);
            return addNewNotifcation('No members selected.', 'warning');
        }

        // Same authorization guard the row action applies, now enforced for every
        // member in a bulk selection: an admin may not remove other admins. The
        // server refuses these too (401) — filtering first keeps the failure
        // explainable instead of reporting a mystery partial failure.
        const blocked = roleInstance.isSuperAdmin
            ? []
            : selection.filter((member) => member.role === 'admin');
        const removable = selection.filter((member) => !blocked.includes(member));

        if (removable.length === 0) {
            setBtnLoading(false);
            setAlertModal(false);
            return addNewNotifcation('Sorry, you are not authorized to remove admin members', 'warning');
        }

        // One request per member — the endpoint takes a single userId.
        Promise.allSettled(
            removable.map((member) =>
                httpRequest
                    .post('/db/organizations/update_organization/remove-member', {
                        organizationId: oragID,
                        userId: member._id,
                    })
                    .then(() => member)
                    .catch((error) => {
                        throw {
                            member,
                            error,
                        };
                    })
            )
        )
            .then((results) => {
                const removed = results
                    .filter((r) => r.status === 'fulfilled')
                    .map((r) => r.value);
                const failed = results
                    .filter((r) => r.status === 'rejected')
                    .map((r) => r.reason);

                if (removed.length > 0) {
                    const removedIds = new Set(removed.map((member) => member._id));
                    setTableData((prev) => prev.filter((item) => !removedIds.has(item._id)));
                }

                // Report what actually happened. A partial failure silently
                // reported as success is how a member appears removed, then
                // returns on the next page load.
                if (failed.length === 0) {
                    addNewNotifcation(
                        removed.length === 1
                            ? 'Organization member removed successfully.'
                            : `${removed.length} organization members removed successfully.`,
                        'success'
                    );
                } else if (removed.length === 0) {
                    addNewNotifcation(
                        `Organization Member could not be removed. ${removalErrorMessage(failed[0].error)}`,
                        failed[0].error.response?.status === 404 ? 'warning' : 'danger'
                    );
                } else {
                    addNewNotifcation(
                        `${removed.length} removed, ${failed.length} could not be removed. ${removalErrorMessage(failed[0].error)}`,
                        'warning'
                    );
                }

                if (blocked.length > 0) {
                    addNewNotifcation(
                        `${blocked.length} admin member(s) were skipped — you are not authorized to remove admins.`,
                        'warning'
                    );
                }

                setAlertModal(false);
            })
            .finally(() => {
                setBtnLoading(false);
            });
    };

    const handleDeleteSelected = (selectedItems) => {
        if (roleInstance.isSuperAdmin || roleInstance.isAdmin) {
            setAlertModal(true);
            setSelectedItem(selectedItems);
        } else {
            addNewNotifcation('Sorry, you are not authorized to remove users', 'danger');
        }
    };

    const userRowActions = [
        {
            name: 'Edit',
            icon: <MdEdit size={18} />,
            onclick: handleUpdate
        },
        {
            name: 'Remove',
            icon: <MdDelete size={18} color='var(--primary-color)' />,
            onclick: handleDelete
        },
    ];

    const userTableActions = [
        {
            name: 'Delete Selected',
            icon: <MdDelete size={18} color='var(--primary-color)' />,
            onclick: handleDeleteSelected
        },
        {
            name: 'Add New',
            icon: <BsPersonFillAdd size={18} />,
            onclick: () => setOpenModal(true)
        }
    ];

    const actionCondition = (row) => {
        return row?.role !== 'super admin';
    };

    if (loading) {
        return <div className='flex flex-grow'> <AppLoader size={50} /> </div>;
    }

    return (
        <div className='flex p-8 overflow-y-scroll w-full min-w-[700px]'>
            <div className="w-full">
                <div className='py-4 h-auto'>
                    {roleInstance.isEditor ? (
                        <NewStyledTable cardTitle={`Manage User (${tableData.length})`} columns={[{
                            field: 'name',
                            headerName: 'Name'
                        }, {
                            field: 'email',
                            headerName: 'Email'
                        }, {
                            field: 'role',
                            headerName: 'Role'
                        }]} data={tableData} rowActions={userRowActions}/>
                    ) : (
                        <NewStyledTable cardTitle={`Manage User (${tableData.length})`} columns={[{
                            field: 'name',
                            headerName: 'Name'
                        }, {
                            field: 'email',
                            headerName: 'Email'
                        }, {
                            field: 'role',
                            headerName: 'Role'
                        }]} data={tableData} rowActions={userRowActions} tableActions={userTableActions} actionCondition={actionCondition} multiSelect={true}/>
                    )}

                    {/* add new user modal */}
                    <Dialog open={openModal} onOpenChange={setOpenModal}>
                        <DialogContent className="w-full max-w-lg p-8 bg-white rounded-lg shadow-lg">
                            <DialogHeader>
                                <DialogTitle className="text-2xl font-semibold">Add User</DialogTitle>
                                <DialogDescription className="text-md text-muted-foreground">Choose to add or invite a user to your organization.</DialogDescription>
                            </DialogHeader>
                            <Tabs value={currentTab} onValueChange={setCurrentTab}>
                                <TabsList className="space-x-4 bg-muted p-3 rounded-lg">
                                    <TabsTrigger value="add-member" className="border-none shadow-none">Add User</TabsTrigger>
                                    <TabsTrigger value="invite-member" className="border-none shadow-none">Invite User</TabsTrigger>
                                </TabsList>
                                <TabsContent value="add-member">
                                    <AddUserForm userInput={userInput} setUserInput={setUserInput} />
                                </TabsContent>
                                <TabsContent value="invite-member">
                                    <InviteUserForm userInput={inviteUserInput} setUserInput={setInviteUserInput} />
                                </TabsContent>
                            </Tabs>
                            <DialogFooter className="flex justify-end space-x-5 mt-6">
                                <Button variant="outline" onClick={() => setOpenModal(false)} className="px-5 py-3 size-md border-solid shadow-none text-accent-foreground">Cancel</Button>
                                <Button onClick={currentTab === 'add-member' ? handleCreate : handleInvite} className="px-5 py-3 text-md">
                                    {btnLoading ? <LoaderSpinner /> : currentTab === 'add-member' ? 'Add User' : 'Invite User'}
                                </Button>
                            </DialogFooter>
                        </DialogContent>
                    </Dialog>

                    {/* remove user */}
                    <AlertModal
                        loading={btnLoading}
                        setopenModal={setAlertModal}
                        openModal={alertModal}
                        onDelete={handleOnDelete}
                    />

                    {/* update user modal */}
                    <UpdateUserMemberDialog setOpenUpdateModal={setOpenUpdateModal} openUpdateModal={openUpdateModal} selectedItem={selectedItem}
                        setSelectedItem={setSelectedItem} setTableData={setTableData} />
                </div>
            </div>
        </div>
    );
}

const UpdateUserMemberDialog = ({
    setOpenUpdateModal, openUpdateModal, selectedItem, setSelectedItem, setTableData
}) => {

    const [btnLoading, setBtnLoading] = useState(false);

    const {
        addNewNotifcation
    } = useContext(Context);
    const {
        oragID
    } = useParams();

    const handleOnUpdate = () => {

        const updateOrgObj = {
            type: selectedItem.role,
            userId: selectedItem._id,
            organizationId: oragID
        };

        setBtnLoading(true);
        httpRequest.post('/db/organizations/update_organization/update-user-role', updateOrgObj)
            .then(() => {

                setTableData(prev => {
                    return prev.map(item => (
                        item._id === selectedItem._id ? {
                            ...item,
                            role: selectedItem.role
                        } : item
                    ));
                });

                addNewNotifcation('User Role updated successfully.', 'success');
                setOpenUpdateModal(false);
            })
            .catch((error) => {

                if (error.response?.status === 404)
                    addNewNotifcation('User Role could not be updated. User is not registered. Please check all your entries.', 'warning');
                else if (error.response?.status === 401)
                    addNewNotifcation('User Role could not be updated. You are not authorized to update.', 'warning');
                else
                    addNewNotifcation('User Role could not be updated. Please try again.', 'danger');
            })
            .finally(() => setBtnLoading(false));

    };

    return (
        <Dialog open={openUpdateModal} onOpenChange={setOpenUpdateModal}>
            <DialogContent className="w-full max-w-lg p-8 bg-white rounded-lg shadow-lg">
                <AddUserForm userInput={selectedItem} setUserInput={setSelectedItem} disabledEmail={true} />

                <DialogFooter className="flex justify-end space-x-5 mt-6">
                    <Button variant="outline" onClick={() => setOpenUpdateModal(false)} className="px-5 py-3 size-md border-solid shadow-none text-accent-foreground">
                        Cancel
                    </Button>
                    <Button disabled={btnLoading} onClick={handleOnUpdate} className="px-5 py-3 text-md">
                        Update
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default UsersSetting;
